export const LIFETIME_PERIODICITY = null;
